const verification_record = {
    not_found: 'Verifizierungsdatensatz nicht gefunden.',
    permission_denied: 'Zugriff verweigert, bitte erneut authentifizieren.',
    not_supported_for_google_one_tap: 'Diese API unterstützt Google One Tap nicht.',
};
export default Object.freeze(verification_record);
